module.exports = __webpack_public_path__ + "static/media/headshot.d423a54c.jpg";